export const VERTICAL_DIV_SEPARATION_MARGIN_FACTOR =
  process.env.REACT_APP_VERTICAL_DIV_SEPARATION_MARGIN_FACTOR;
export const BASEURL = process.env.REACT_APP_BASEURL;
export const AGENT_LED_JOURNEY_URL =
  process.env.REACT_APP_AGENT_LED_JOURNEY_URL;
export const APP_ID = parseInt(process.env.REACT_APP_APP_ID);
export const APP_VERSION = process.env.REACT_APP_APP_VERSION;
export const GENERATE_AUTHTOKEN_API_USERNAME =
  process.env.REACT_APP_GENERATE_AUTHTOKEN_API_USERNAME;
// Simple Hack for fixing $ sign not showing in password from env
export const GENERATE_AUTHTOKEN_API_PASSWORD = "e$!Ntern@L"; //process.env.REACT_APP_GENERATE_AUTHTOKEN_API_PASSWORD;//"e$!Ntern@L"
export const GENERATE_AUTHTOKEN_API_APPLICATIONNAME =
  process.env.REACT_APP_GENERATE_AUTHTOKEN_API_APPLICATIONNAME;

export const SAVEORDER = process.env.REACT_APP_SAVEORDER;
export const SAVE_NEW_CUSTOMER_ORDER =
  process.env.REACT_APP_SAVE_NEW_CUSTOMER_ORDER;
export const GENERATE_AUTH_TOKEN = process.env.REACT_APP_GENERATE_AUTH_TOKEN;
export const GET_PRODUCT_CATEGORIES =
  process.env.REACT_APP_GET_PRODUCT_CATEGORIES;
export const GET_SSO_TOKEN = process.env.REACT_APP_GET_SSO_TOKEN;
export const SEND_LINK = process.env.REACT_APP_SEND_LINK;
export const CHECKOUT_COMMUNICATION =
  process.env.REACT_APP_CHECKOUT_COMMUNICATION;

export const ADD_PREFFERED_TIME_API =
  process.env.REACT_APP_ADD_PREFFERED_TIME_API;

export const ADD_PROCEED_URL = process.env.REACT_APP_ADD_PROCEED_URL;

export const ADD_MERCHANT_INFO = process.env.REACT_APP_ADD_MERCHANT_INFO;

export const VALIDATE_SSO = process.env.REACT_APP_VALIDATE_SSO;
export const PROF_DECISION = process.env.REACT_APP_PROF_DECISION;
export const WP_NOTIF_SEND_OTP = process.env.REACT_APP_WP_NOTIF_SEND_OTP;
export const WP_NOTIF_UPDATE_AGENT =
  process.env.REACT_APP_WP_NOTIF_UPDATE_AGENT;

// for new qec
export const LOAUTOMATE = process.env.REACT_APP_LOAUTOMATE;
export const TOKENGEN = process.env.REACT_APP_TOKENGEN;
export const PANPREPOPULATE = process.env.REACT_APP_PANPREPOPULATE;
export const VALIDATEPINCODE = process.env.REACT_APP_VALIDATEPINCODE;

export const MERCHANTFIELD_CONFIG = process.env.REACT_APP_MERCHANTFIELD_CONFIG;
//for calculate emi
export const GETMERCHANT_LIST = process.env.REACT_APP_GETMERCHANT_LIST;
export const GETSTUDENT_DETAILS = process.env.REACT_APP_GETSTUDENT_DETAILS;
export const GETSUBMERCHANT_LIST = process.env.REACT_APP_GETSUBMERCHANT_LIST;
export const GETPRODUCTEMI_LIST = process.env.REACT_APP_GETPRODUCTEMI_LIST;
//For QEC INGESTION
export const QEC_INGESTION = process.env.REACT_APP_QEC_INGESTION;
export const UPDATE_SCHOOL_ORDER_AMOUNT =
  process.env.REACT_APP_UPDATE_SCHOOL_ORDER_AMOUNT;
// Get School List for Miscall Landing page//
export const GET_SCHOOL_LIST = process.env.REACT_APP_GET_SCHOOL_LIST;
export const SAVE_SCHOOL_INFO = process.env.REACT_APP_SAVE_SCHOOL_INFO;
export const GET_API_KEY = process.env.REACT_APP_GET_API_KEY;
export const SENDOTPLOGIN = process.env.REACT_APP_SENDOTPLOGIN;
export const VERIFYOTPLOGIN = process.env.REACT_APP_VERIFYOTPLOGIN;
export const ISREPEATCUSTOMER = process.env.REACT_APP_IS_REPEATCUSTOMER;
export const VALIDATE_SSO_3O = process.env.REACT_APP_VALIDATE_SSO_3O;
export const INTERNAL_SAVE_ORDER = process.env.REACT_APP_INTERNAL_SAVE_ORDER;
export const PORTAL_BASE_URL = process.env.REACT_APP_PORTAL_BASE_URL;
export const ENCRYPTED_X_API_KEY = process.env.REACT_APP_ENCRYPTED_X_API_KEY;
export const DATALAKE_TRACKER_URL = process.env.REACT_APP_DEFAULT_TRACKING_URL;